import { ZodType, z } from 'zod';

export function nonNull<T>(x: T): x is NonNullable<T> {
	return x !== undefined && x !== null;
}

export function toMap<T, K>(a: T[], keyMap: (x: T) => K): Map<K, T> {
	return a.reduce((o, x) => {
		o.set(keyMap(x), x);
		return o;
	}, new Map());
}

export function convertKeys<T, K1, K2>(
	m: Map<K1, T>,
	keyMap: (k: K1) => K2,
): Map<K2, T> {
	return new Map(Array.from(m.entries()).map(([k, v]) => [keyMap(k), v]));
}

export const zodParseJSON = z.string().transform((str: string, ctx) => {
	try {
		return JSON.parse(str);
	} catch (e) {
		ctx.addIssue({ code: 'custom', message: 'Invalid JSON' });
		return z.NEVER;
	}
}).pipe;

export const zodPhpArrayObject = <T extends ZodType>(innerType: T) =>
	z
		.union([
			z.array(innerType),
			z.record(z.union([z.string(), z.number()]), innerType),
		])
		.transform((arrayOrObject) =>
			Array.isArray(arrayOrObject)
				? arrayOrObject
				: Array.from(Object.values(arrayOrObject)),
		);
